<template>
    <div class="learning-path-profile">
        <div class="row">
            <div class="col-12 col-xl-4 aside-wrapper">
                <design-2021-learning-path-recent-assignments-component :lp-assignments-in="lpAssignmentsIn">
                </design-2021-learning-path-recent-assignments-component>

                <design-2021-personal-goal-widget-component
                    :personal-goals-in="personalGoalsIn"
                    :teacher-access="teacherAccess"
                    :user-credentials-in="userCredentialsIn">
                </design-2021-personal-goal-widget-component>
            </div>

            <div class="col-12 col-xl-8">
                <design-2021-profile-timeline-widget-component :cards-in="cardsIn"
                                                               :categories-in="categoriesIn"
                                                               :user-credentials-in="userCredentialsIn"
                                                               :teacher-access="teacherAccess"
                                                               :seasons-in="seasonsIn">
                </design-2021-profile-timeline-widget-component>

                <design-2021-survey-results-index-component
                    :skill-trees-in="skillTreesIn">
                </design-2021-survey-results-index-component>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-6 col-xl-4">

            </div>
            <div class="col-12 col-sm-6 col-xl-8">

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "design-2021-learning-path-profile-component",
    props:{
        cardsIn: {
            type: Array,
            required: true,
        },
        categoriesIn: {
            type: Array,
            required: true,
        },
        userCredentialsIn: {
            type: Object,
            required: true,
        },
        teacherAccess: {
            type: Number,
            required: false,
            default: ()=> {
                return 0
            }
        },
        seasonsIn: {
            type: Array,
            required: true,
        },
        personalGoalsIn: {
            type: Array,
            required: true,
        },
        skillTreesIn: {
            type: Array,
            required: true,
        },
        lpAssignmentsIn: {
            type: Array,
            required: true,
        },
    }
}
</script>

<style scoped lang="scss">
    .aside-wrapper {
        margin-bottom: map-get($grid-gutter-spacing, 'sixty');
    }
</style>
